import { render, staticRenderFns } from "./IconLinkedIn.vue?vue&type=template&id=24d70027&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24d70027')) {
      api.createRecord('24d70027', component.options)
    } else {
      api.reload('24d70027', component.options)
    }
    module.hot.accept("./IconLinkedIn.vue?vue&type=template&id=24d70027&", function () {
      api.rerender('24d70027', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/IconLinkedIn.vue"
export default component.exports